import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { PaginatedResponse } from '@/core/api/dtos/common/types'
import { BrandIdentity } from '@/core/api/entities/brandIdentity'
import { BrandIdentityMapper } from '@/core/api/mappers/brandIdentityMapper'
import { brandIdentityService } from '@/core/api/services/brandIdentityService'

import { DEFAULT_PARAMS } from '@core/hooks/common'

/**
 * Get brand identities
 */
export const useBrandIdentities = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<
	PaginatedResponse<BrandIdentity>,
	Error
> => {
	const QUERY_KEY = [
		'brand-identities',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			brandIdentityService
				.getBrandIdentities(config)
				.then(({ data: response }) => {
					return {
						data: BrandIdentityMapper.toEntities(response.data),
						meta: response.meta,
					}
				}),
		cacheTime: 5 * 60 * 1000, // 5 minutes
		staleTime: 2 * 60 * 1000, // 2 minutes
		...options,
	})
}
